module.exports = ".note {\n  font-style: italic;\n  opacity: 0.5; }\n"